import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
  outlinedClass: {
    margin: "10px 0px",
    borderRadius: "10px",
    border: "1px solid #ddd",
  },
}));
